module.exports = __webpack_public_path__ + "img/alagoas.e3c3773c.jpg";